"use client";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTheme } from "../theme/ThemeContext";
import { useTranslations } from "next-intl";

export interface InvestingBarProps {
  value?: number;
  min?: number;
  max?: number;
}

export default function InvestingBar({ value = 0, min = -3, max = 3 }: InvestingBarProps) {
  const theme = useTheme();
  const t = useTranslations();
  const cursorWidthRem = 0.25;

  // 裁剪 value 到边界
  const clippedValue = Math.max(min, Math.min(max, value));

  // 计算目标位置百分比
  const percent = (clippedValue - min) / (max - min);
  const [leftPercent, setLeftPercent] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setLeftPercent(percent), 50);
    return () => clearTimeout(timer);
  }, [percent]);

  return (
    <Box sx={{ width: "100%", pb: "1rem" }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "0.75rem",
          mb: "0.375rem",
          background: "linear-gradient(90deg,  #A62F3D 0%,  #E05357 33%,  #139E79 66%,  #00694F 100%)",
          borderRadius: "0.625rem",
          cursor: "default",
          userSelect: "none",
        }}>
        {/* 光标 */}
        <Box
          sx={{
            position: "absolute",
            top: `-0.375rem`,
            left: `calc(${leftPercent * 100}% - ${cursorWidthRem / 2}rem)`,
            width: `${cursorWidthRem}rem`,
            height: "1.5rem",
            borderRadius: "0.1875rem",
            background: theme.isDarkMode ? "#F1F1F1" : "#141618",
            border: "1px solid",
            borderColor: theme.isDarkMode ? "#141618" : "#F1F1F1",
            zIndex: 2,
            pointerEvents: "none",
            transition: "left 0.7s cubic-bezier(0.4,0,0.2,1)",
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          color: "text.secondary",
          fontSize: "var(--font-size-xs)",
        }}>
        <span>{t("Metrics.signal.marketValuation.sell")}</span>
        <span>{t("Metrics.signal.marketValuation.buy")}</span>
      </Box>
    </Box>
  );
}
